var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ResourcesListHorizontal,{attrs:{"resources":_setup.resources,"title":_vm.title,"subheading":_vm.subheading,"link":_vm.link,"is-loading":_setup.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }